import { PREDICATE_OPERATORS } from '../../constants';

/**
 * A time predicate for a temporal JQL clause.
 */

/**
 * The operator used in a time predicate.
 */

// Guards

export var isPredicateOperator = function isPredicateOperator(operator) {
  return PREDICATE_OPERATORS.includes(operator);
};